import { __ } from '@wordpress/i18n';
import './PlaceholderLoader.css';

const PlaceholderLoader = () => {
  return (
    <div className="hvnly--builder---api_property__builder__main-container hvnly-placeholder-settings-api_property__builder__main-container">
      {/* Left Side - Editor Placeholder */}
      <div className="hvnly--builder---api_property__builder__left-panel">
        <h2 className="hvnly--builder---api_property__builder__section-title">{__('Property Card Builder', 'havenlytics')}</h2>
        <div className="hvnly--builder---api_property__builder__card__container">
          <div className="hvnly--builder---api_property__builder___preview_section">
            <div className="hvnly-placeholder-single-page-card">
              {/* Header with Thumbnail */}
              <div className="hvnly-placeholder-single-page-card-header">
                <div className="hvnly-placeholder-thumbnail-area"></div>
                <div className="hvnly-placeholder-corner top-left"></div>
                <div className="hvnly-placeholder-corner top-right"></div>
                <div className="hvnly-placeholder-corner bottom-left"></div>
                <div className="hvnly-placeholder-corner bottom-right"></div>
              </div>
              
              {/* Body Section */}
              <div className="hvnly-placeholder-single-page-card-body">
                <div className="hvnly-placeholder-avatar-title-container">
                  <div className="hvnly-placeholder-avatar-area"></div>
                  <div className="hvnly-placeholder-title-area">
                    <div className="hvnly-placeholder-title-line"></div>
                    <div className="hvnly-placeholder-title-line short"></div>
                  </div>
                </div>
                
                <div className="hvnly-placeholder-content-area">
                  <div className="hvnly-placeholder-content-line"></div>
                  <div className="hvnly-placeholder-content-line"></div>
                </div>
                
                <div className="hvnly-placeholder-features-area">
                  <div className="hvnly-placeholder-feature-line"></div>
                </div>
                
                <div className="hvnly-placeholder-excerpt-area">
                  <div className="hvnly-placeholder-excerpt-line"></div>
                  <div className="hvnly-placeholder-excerpt-line short"></div>
                </div>
              </div>
              
              {/* Footer Section */}
              <div className="hvnly-placeholder-single-page-card-footer">
                <div className="hvnly-placeholder-footer-left">
                  <div className="hvnly-placeholder-footer-item"></div>
                </div>
                <div className="hvnly-placeholder-footer-right">
                  <div className="hvnly-placeholder-footer-item"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Preview Placeholder */}
      <div className="hvnly--builder---api_property__builder__right-panel">
        <h2 className="hvnly--builder---api_property__builder__section-title">{__('Property Card Preview', 'havenlytics')}</h2>
        <div className="hvnly--builder---api_property__builder___enhanced_card_preview_container">
          <div className="hvnly-placeholder-enhanced-preview-card">
            {/* Image Section */}
            <div className="hvnly-placeholder-enhanced-preview-card-image-section">
              <div className="hvnly-placeholder-enhanced-preview-card-image">
                <div className="hvnly-placeholder-image-bg"></div>
                <div className="hvnly-placeholder-overlay-top">
                  <div className="hvnly-placeholder-image-left">
                    <div className="hvnly-placeholder-overlay-item"></div>
                  </div>
                  <div className="hvnly-placeholder-image-right">
                    <div className="hvnly-placeholder-overlay-item"></div>
                  </div>
                </div>
                <div className="hvnly-placeholder-overlay-bottom">
                  <div className="hvnly-placeholder-image-left">
                    <div className="hvnly-placeholder-overlay-item"></div>
                  </div>
                  <div className="hvnly-placeholder-image-right">
                    <div className="hvnly-placeholder-overlay-item"></div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Body Section */}
            <div className="hvnly-placeholder-enhanced-preview-card-body">
              <div className="hvnly-placeholder-enhanced-preview-card-header">
                <div className="hvnly-placeholder-enhanced-preview-card-avatar"></div>
                <div className="hvnly-placeholder-enhanced-preview-card-title-section">
                  <div className="hvnly-placeholder-enhanced-preview-card-title"></div>
                  <div className="hvnly-placeholder-enhanced-preview-card-rating"></div>
                  <div className="hvnly-placeholder-enhanced-preview-card-location"></div>
                </div>
              </div>
              
              <div className="hvnly-placeholder-enhanced-preview-card-excerpt">
                <div className="hvnly-placeholder-excerpt-line"></div>
                <div className="hvnly-placeholder-excerpt-line"></div>
                <div className="hvnly-placeholder-excerpt-line short"></div>
              </div>
              
              <div className="hvnly-placeholder-enhanced-preview-card-features">
                <div className="hvnly-placeholder-feature-item"></div>
                <div className="hvnly-placeholder-feature-item"></div>
                <div className="hvnly-placeholder-feature-item"></div>
                <div className="hvnly-placeholder-feature-item"></div>
              </div>
              
              <div className="hvnly-placeholder-enhanced-preview-card-content-area">
                <div className="hvnly-placeholder-detail-item"></div>
                <div className="hvnly-placeholder-detail-item"></div>
                <div className="hvnly-placeholder-detail-item"></div>
              </div>
            </div>
            
            {/* Footer Section */}
            <div className="hvnly-placeholder-enhanced-preview-card-footer">
              <div className="hvnly-placeholder-enhanced-preview-card-category">
                <div className="hvnly-placeholder-footer-button"></div>
              </div>
              <div className="hvnly-placeholder-enhanced-preview-card-actions">
                <div className="hvnly-placeholder-action-btn"></div>
                <div className="hvnly-placeholder-action-btn"></div>
                <div className="hvnly-placeholder-views"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderLoader;